export const ENCRYPT_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
export const IMG_PATH = "https://drive.google.com/thumbnail?id=";
export const FETCH_KEY = process.env.REACT_APP_FETCH_KEY;